import { createGlobalStyle } from 'styled-components/macro';
import '@fortawesome/fontawesome-free/css/all.css';

const GlobalStyle = createGlobalStyle`
  /**
   * Reset
   *  http://meyerweb.com/eric/tools/css/reset/
   * v2.0 | 20110126
   * License: none (public domain)
   */

  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    vertical-align: baseline;
  }
  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }
  body {
    line-height: 1;
  }
  ol, ul {
    list-style: none;
  }
  blockquote, q {
    quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  /**
   * Fonts
   */
  @font-face {
    font-family: 'Roboto Condensed';
    font-style: normal;
    font-weight: 500;
    src:  url(${process.env.PUBLIC_URL}/fonts/Roboto_Condensed/RobotoCondensed-Regular.ttf) format('truetype');
  }

  @font-face {
    font-family: 'Roboto Condensed';
    font-style: normal;
    font-weight: 700;
    src:  url(${process.env.PUBLIC_URL}/fonts/Roboto_Condensed/RobotoCondensed-Bold.ttf) format('truetype');
  }

  @font-face {
    font-family: 'Roboto Condensed';
    font-style: italic;
    font-weight: 700;
    src: lurl(${process.env.PUBLIC_URL}/fonts/Roboto_Condensed/RobotoCondensed-BoldItalic.ttf) format('truetype');
  }

  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    src: url(${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-Regular.ttf) format('truetype');
  }

  @font-face {
    font-family: 'Roboto-Italic';
    font-weight: 500;
    src: url(${process.env.PUBLIC_URL}/fonts/Roboto/Roboto-Italic.ttf) format('truetype');
  }

  @font-face {
    font-family: 'Roboto-Slab';
    font-style: normal;
    font-weight: 500;
    src: url(${process.env.PUBLIC_URL}/fonts/Roboto_Slab/static/RobotoSlab-Regular.ttf) format('truetype');
  }

  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  * {
    box-sizing: border-box;
  }

  /**
   * Root font size
   */
  html {
    font-family: "Roboto", Arial, sans-serif;
    font-size: 16px;
    line-height: 1.6em;
  }

  /**
   * Fill the window
   */
  html {
    position: relative;
    height: 100%;
  }

  body, #root {
    position: relative;
    width: 100%;
    height: 100%;

  }

  a {
    &:link {
      color: #3bc0c3;
      text-decoration: none;
    }

    &:visited {
      color: #3bc0c3;
    }
  }

  /* proportionally scale images */
  img {
    width: 100%;
    height: auto;
    height: intrinsic; /* for safari */
  }

  h2 {
    font-family: "Roboto Condensed";
    font-weight: bold;
    font-size: 36px;
    color: #3c4f5b;
    text-transform: uppercase;
    text-align: center;
    line-height: 1.6;
    margin-bottom: 42px;
  }

  h3 {
    font-family: "Roboto";
    font-weight: bold;
    font-size: 28px;
    margin-bottom: 1.6em;
    color: #5D7A8C;
    letter-spacing: 0.75px;
  }

  h4 {
    font-family: "Roboto";
    font-weight: bold;
    font-size: 18px;
    margin-bottom: 0.8em;
    color: #5D7A8C;
  }

  h6 {
    font-size: 1.2em;
    font-weight: normal;
    margin-bottom: 48px;
  }

  p {
    font-family: Roboto;
    font-size: 16px;
    color: #282A2B;
    letter-spacing: 0.5px;
  }

  ul {
    list-style-type: none;
    margin-left: 12px;
    margin-bottom: 1.61em;
  }

  ul li::before {
    content: '⦿';
    color: #A78A38;
    font-size: 1.1em;
    font-weight: bold;
    width: 1.1em;
    margin-left: 0;
    margin-right: 0.8em;
  }

  p, li {
    font-weight: normal;
    line-height: 1.61;
    margin-bottom: 1.6em;
  }
`;

export default GlobalStyle;
